<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-3 mb-1 textLight--text px-4 px-md-2 mouse-cursor premium-list-card"
    >
      <v-row align="center" class="pa-3 pa-md-0">
        <v-col cols="auto" class="text-start ps-md-7" style="width: 120px">
          <v-checkbox
            :input-value="isSelected"
            @change="$emit('onChange', $event)"
            class="mt-0 pt-0 d-inline-flex"
            hide-details
          />
        </v-col>

        <v-col cols="auto" class="text-start" style="width: 250px">
          <div class="text-ellipse-2">
            {{
              data.organizationName
                ? getLocalisedValue(data.organizationName)
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="auto" class="text-start" style="width: 250px">
          <div class="text-ellipse-2">
            {{
              data.trainingTitle ? getLocalisedValue(data.trainingTitle) : "-"
            }}
          </div>
        </v-col>

        <v-col cols="auto" class="text-start" style="width: 250px">
          <div class="text-ellipse-2">
            <span>
              {{
                data.employee && data.employee.user
                  ? `${data.employee.user.firstName || ""} ${
                      data.employee.user.lastName || ""
                    }`
                  : "-"
              }}
            </span>
          </div>
        </v-col>

        <v-col cols="auto" class="text-start" style="width: 180px">
          <div>
            {{
              data.completedAt
                ? moment(parseInt(data.completedAt)).format("DD MMM YYYY")
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="auto" class="text-start" style="width: 150px">
          <div
            class="text-capitalize"
            :class="
              data.trainingMode === 'ONLINE'
                ? 'success--text'
                : data.trainingMode === 'OFFLINE'
                ? 'warning--text'
                : ''
            "
          >
            {{ data.trainingMode ? data.trainingMode.toLowerCase() : "-" }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CertificatesTableRow",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.premium-list-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid rgba(0, 0, 0, 0.03) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02) !important;
  background-color: #ffffff !important;
}
.premium-list-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(98, 0, 234, 0.1) !important;
  background-color: #ffffff !important;
}
</style>
